import { fetchStart, fetchError, fetchSuccess } from './Common';
import axios from 'axios';
import { GET_CITIES } from '../../@jumbo/constants/ActionTypes';
import { getCitiesApi } from 'redux/apis/Users';

export const getCities = (search = '', callbackFun) => {
  return dispatch => {
    dispatch(fetchStart());
    getCitiesApi(search)
      .then(data => {
        dispatch(fetchSuccess());
        dispatch({ type: GET_CITIES, payload: data.cities });
        if (callbackFun) callbackFun(data.cities);
      })
      .catch(error => {
        dispatch(fetchError('There was something issue in responding server'));
      });
  };
};
